import { supo } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { areQuestionsLoaded, areModalQuestionsLoaded } from '../selectors/questions';
import { Question } from '../interfaces/question';
import { Action, Dispatch } from 'redux';

interface FetchSuccessPayload {
  questions: Question[];
  key: string;
}

export interface FetchSuccessAction extends Action {
  type: string;
  payload: FetchSuccessPayload;
}

export const fetchQuestions = (key: string) => {
  return async (dispatch: Dispatch, getState): Promise<FetchSuccessAction> => {
    if (!key) return;
    if (areQuestionsLoaded(getState(), key)) return;

    const { data: questions } = await supo.get<Question[]>(`/questions/${key}`);

    return dispatch({
      type: ActionTypes.FETCH_QUESTIONS_SUCCESS,
      payload: { questions, key },
    });
  };
};

export const fetchModalQuestions = key => {
  return async (dispatch, getState) => {
    if (!key) return;
    if (areModalQuestionsLoaded(getState(), key)) return;
    const { data: questions } = await supo.get(`/form/questions/${key}`);
    return dispatch({
      type: ActionTypes.FETCH_MODAL_QUESTIONS_SUCCESS,
      payload: { questions, key },
    });
  };
};
